import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from './Icons';
const risks = ['Dead fronds build up in your palm canopy', 'That overhanging branch gets heavier with each rain', 'The stump in your yard continues to trip people up', 'Your curb appeal suffers and your property value with it'];
export const UrgencySection = () => {
  return <section className="py-24 bg-white" data-id="element-322">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-323">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-324">
          <h2 className="text-3xl md:text-5xl font-black text-red-600 mb-6 uppercase tracking-tight" data-id="element-325">
            Don't Wait Until Something Goes Wrong
          </h2>
          <p className="text-2xl font-bold text-charcoal mb-12" data-id="element-326">
            Every week you wait is another week that:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-16 text-left" data-id="element-327">
            {risks.map((risk, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-red-50 p-6 rounded-2xl border border-red-100" data-id="element-328">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-200 text-red-700 flex items-center justify-center mt-0.5" data-id="element-329">
                  <XIcon className="w-5 h-5" data-id="element-330" />
                </div>
                <p className="text-red-900 font-semibold text-lg" data-id="element-331">{risk}</p>
              </motion.div>)}
          </div>

          <div className="inline-block bg-charcoal text-white px-8 py-4 rounded-xl text-xl font-bold shadow-xl" data-id="element-332">
            The cost of prevention is always less than the cost of damage.
          </div>
        </motion.div>
      </div>
    </section>;
};